// import jwt from "jsonwebtoken";
import * as jose from "jose";
import axios from "axios";

async function encodeBodyRequest(_payload) {
  try {
    //! Pick characers randomly 32 digit
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let ramdomstring = "";
    for (let i = 0; i < 32; i++) {
      ramdomstring += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    let call_api = await axios.get(process.env.VUE_APP_API_FACTORING_SERVICE + "/timestamp/");

    if (call_api.data.status === "OK") {
      //! Create variable & Append timestamp in _payload
      let body_payload = _payload;
      body_payload["timestamp"] = call_api.data.message.timestamp;
      //! Create Jwt Token
      const secret = new TextEncoder().encode("bill");
      const jwt_generate = await new jose.SignJWT(body_payload)
        .setProtectedHeader({ alg: "HS256" })
        .sign(secret);
      //! Split Token
      let jwt_split = jwt_generate.split(".");
      //! Add characters randomly In JWT PAYLOAD
      jwt_split[1] += ramdomstring;
      //! Create Body Request Encode & Ramdom Postiton JWT Header.Payload.Signature => Signature.Header.Payload
      const body_request_encoder = {
        data: jwt_split[2] + "." + jwt_split[0] + "." + jwt_split[1],
      };
      //! Create variable & Append timestamp in header
      let header_auth = {
        timestamp: call_api.data.message.timestamp,
        Authorization: "3c74e8479d32fc75193bb327f8349d90586d9e55e9949cfe50723a54b48265e17487f746dd5cc3118d85fcfda91393e2ea8fa88a28f8f13174297d4b4093a9fd",
      };
      //! Create Jwt Token Header
      const jwt_generate_header = await new jose.SignJWT(header_auth)
        .setProtectedHeader({ alg: "HS256" })
        .sign(secret);
      //! Split Token Header
      let jwt_split_header = jwt_generate_header.split(".");
      //! Add characters randomly In JWT PAYLOAD
      jwt_split_header[1] += ramdomstring;
      //! Create Body Request Encode & Ramdom Postiton JWT Header.Payload.Signature => Signature.Header.Payload
      const header_request_encoder = {
        Authorization: jwt_split_header[2] + "." + jwt_split_header[0] + "." + jwt_split_header[1],
      };
      //! Return body request & Header Authorization
      return new Promise((resolve) => {
        resolve({ header: header_request_encoder, body: body_request_encoder });
        // resolve(body_request_encoder);
      });
    } else {
      throw call_api.data;
    }
  } catch (err) {
    console.error(err);
    return new Promise((resolve, reject) => {
      reject("ไม่สามารถเชื่อมต่อระบบ Timestamp ได้ กรุณาติดต่อผู้ดูแลระบบ");
    });
  }
}

function decodeBodyRequest(_payload) {
  try {
    let type = typeof _payload;
    if (type === "string" && _payload.length > 32) {
      //! get EncodeJwt from _payload & split data
      let rawdata_payload = _payload.split(".");
      //! remove characers randomly 32 digit in JWT Payload
      rawdata_payload[2] = rawdata_payload[2].substr(
        0,
        rawdata_payload[2].length - 32
      );

      //! Set Position JWT Header.Payload.Signature
      const set_jwt =
        rawdata_payload[1] +
        "." +
        rawdata_payload[2] +
        "." +
        rawdata_payload[0];
      //! Decode JWT
      const secret = new TextEncoder().encode("bill");
      const decoded_jwt = jose.decodeJwt(set_jwt, secret);

      return decoded_jwt;
    } else {
      // Object หรือกรณีหลังบ้านส่ง message มาเป็น string แต่ไม่ได้ encode มา
      if (_payload === "success") {
        return { message: "success", status: "OK" };
      }
      return _payload;
    }
  } catch (error) {
    console.log("decode error", error);
  }
}

function decodeResponse(_result, _key = "message") {
  // console.log(_result, "response_api");
  let response_api;
  let onlyOneKey = Object.keys(_result.data);
  if (_key in _result.data && onlyOneKey.length === 1) {
    // หลังบ้านไม่ได้เปลี่ยนบาง response มาเป็น encrypt ทุกตัว
    if (typeof _result.data.message === "string") {
      let decoded = decodeBodyRequest(_result.data.message);
      if (decoded instanceof Promise) {
        return decoded.then((res) => {
          // console.log(res, "decodeResponse");
          return res;
        });
      }
      response_api = decoded;
    } else {
      response_api = _result.data;
    }
  } else {
    response_api = _result.data;
  }
  // console.log(response_api, "decodeResponse");
  return response_api;
}

function decodearraybuffer(res) {
  let decodearraybuffer = new TextDecoder("utf-8");
  let msgarraybuffer = decodearraybuffer.decode(res);
  let msgjson = JSON.parse(msgarraybuffer);

  return msgjson;
}

function encodeB64Params(_payload) {
  return window.btoa(unescape(encodeURIComponent(JSON.stringify(_payload))));
}

function decodeB64Params(_payload) {
  return JSON.parse(decodeURIComponent(escape(window.atob(_payload))));
}

export default { encodeBodyRequest, decodeBodyRequest, decodearraybuffer, encodeB64Params, decodeB64Params, decodeResponse };
